<script>
    import { CheckLink, SetEquipment, DelEquipment } from '../../../script/handle/write'
    export let Monster, ShowEquipmentModal, Position
    
    let clientWidth, clientHeight
	let dialog;
    $: if (dialog && ShowEquipmentModal) {
        dialog.showModal(); 
    }

    // Modal 종료
	function closeModal() {
		ShowEquipmentModal = false
		dialog.close()
	}

    function checkEquipNumber(_i, _j) {
        let returnValue = ''
        if(_i < _j || _i == _j)
            returnValue = returnValue + _i + _j
        else if(_i > _j)
            returnValue = returnValue + _j + _i

        return returnValue
    }

    function setEquipment(_equipment) {
        SetEquipment(Monster, _equipment, Position)
        closeModal()
    }

    function delEquipment() {
        DelEquipment(Monster, Position)
        closeModal()
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog
	bind:this={dialog}
	on:close={() => closeModal()}
	on:click|self={() => closeModal()}
    class='equipmentModal'
>
    <div class="title">장비 선택</div>

    <div class="list">        
        {#each Array(8) as _, i}
            {#each Array(8) as _, j}
                {#if i == 0 && j == 0}
                        {#if Position != -1}
                            <button
                                on:click={() => delEquipment()}
                                style="width: {clientWidth-11}px; height:{clientHeight-10}px"
                            >
                                비우기
                            </button>
                        {:else}
                            <div class="item">
                            </div>
                        {/if}
                {:else if i == 0}
                    <div class="item" bind:clientWidth bind:clientHeight>
                        <img
                            src="{CheckLink()}/img/equipment/base/{j}.png"
                            alt="base_{j}"
                        >
                    </div>
                {:else if j == 0}
                    <div class="item">
                        <img
                            src="{CheckLink()}/img/equipment/base/{i}.png"
                            alt="base_{i}"
                        >
                    </div>
                {:else}
                    <div class="item" on:click={() => setEquipment(checkEquipNumber(i, j))}>
                        <img
                            class='equip'
                            src="{CheckLink()}/img/equipment/equip/{checkEquipNumber(i, j)}.png"
                            alt="equip_{checkEquipNumber(i, j)}"
                        >
                    </div>
                {/if}
            {/each} 
        {/each}
    </div>

    <!-- svelte-ignore a11y-autofocus -->
    <div style="text-align: right;">
        <button autofocus on:click={() => dialog.close()}>닫기</button>
    </div>
</dialog>

<style lang='scss'>
    dialog {
        border-radius: 4px;
        border: 1px solid #ffffff;
        padding: 0;
        background-color: $cl1;
        color: #ffffff;

        & > div {
            padding: 10px;
        }

        &::backdrop {
            background: rgba(0, 0, 0, 0.8);
        }

        &[open] {
            animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes zoom {
            from {
                transform: scale(0.95);
            }
            to {
                transform: scale(1);
            }
        }
        &[open]::backdrop {
            animation: fade 0.2s ease-out;
        }
        @keyframes fade {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
    }

    .equipmentModal {
        width: calc(60%);
        height: fit-content;

        .title {
            color: $cl4;
            font-size: 24px;
            font-family: aggro;
        }

        .list {
            width: calc(100% - 20px);
            height: fit-content;
            padding: 10px;
            
            .item {
                width: calc(12.5% - 10px);
                padding: 5px;
                display: inline-block;

                img {
                    width: 100%;

                    &.equip {
                        width: calc(100% - 4px);
                        border: 2px solid $cl1;
                        border-radius: $br1;

                        &:hover {
                            border: 2px solid $cl3;
                            cursor: pointer;
                        }
                    }
                }
            }
            
            button {
                background: none;
                margin: 5px;
                padding: 5px 9px;
                padding-bottom: 5px;
                border: 2px solid $cl3;
                color: $cl2;
                font-size: 14px;
                font-family: aggro;
                vertical-align: top;

                &:hover {
                    background: $cl3;
                }
            }
        }
    }
</style>
